module.exports = __webpack_public_path__ + "img/accsCtlCrdReader2.133fbfb7.png";